import { render, staticRenderFns } from "./PlusIcon.vue?vue&type=template&id=a423bbc8&scoped=true&"
import script from "./PlusIcon.vue?vue&type=script&lang=ts&"
export * from "./PlusIcon.vue?vue&type=script&lang=ts&"
import style0 from "./PlusIcon.vue?vue&type=style&index=0&id=a423bbc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a423bbc8",
  null
  
)

export default component.exports